import styled, { css } from 'styled-components';

import Loader from '../../loader/Loader';

export const StyledFileList = styled.div``;

export const StyledFile = styled.div<{ borderWidth: number }>`
  position: relative;
  height: 40px;
  box-sizing: border-box;
  border: ${({ borderWidth }) => borderWidth}px solid ${({ theme }) => theme.colors.gray13};
  border-bottom-width: 0;
  border-radius: 4px;
  display: flex;
  flex-wrap: nowrap;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  overflow: hidden;

  &:not(:last-child) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:last-child {
    border-bottom-width: ${({ borderWidth }) => borderWidth}px;
  }

  &:not(:first-child) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

export const StyledFileLink = styled.a<{ error: Error; pending: boolean }>`
  border: 0;
  outline: 0;
  padding: 11px 0 11px 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1;
  flex: 1;
  text-align: left;
  color: ${({ theme, pending, error }) => {
    if (pending) return theme.colors.gray14;
    if (error) return theme.colors.text;
    return theme.colors.light;
  }};
  cursor: pointer;
  text-decoration: none;

  ${({ pending, error }) => (pending || error) && css`
    pointer-events: none;
  `}

  &:hover {
    color: ${({ theme }) => theme.colors.lighter};
    text-decoration: underline;
  }

  &:focus {
    box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.lighter};
  }

  &:active {
    color: ${({ theme }) => theme.colors.lightest};
  }
`;

export const StyledButton = styled.button`
  display: block;
  width: 40px;
  height: 40px;
  background: transparent;
  border: 0;
  cursor: pointer;
  outline: 0;
  color: ${({ theme }) => theme.colors.light};
  padding: 11px;
  box-sizing: border-box;
  margin-left: -4px;
  
  &:hover {
    color: ${({ theme }) => theme.colors.lighter};
  }

  &:focus-visible, &:focus {
    box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.lighter};
  }

  &:focus:not(&:focus-visible) {
      box-shadow: none;
      position: relative;
      z-index: 1;
    }

  &:active {
    color: ${({ theme }) => theme.colors.lightest};
  }
`;

export const StyledCloseIcon = styled.svg`
  width: 18px;
  height: 18px;
`;

export const StyledIcon = styled.svg<{ error: Error }>`
  color: ${({ theme, error }) => error ? theme.colors.error : theme.colors.success};
  width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-bottom: -4px;
`;

export const StyledLoader = styled(Loader)`
  display: inline-block;
  margin-right: 8px;
  margin-bottom: -4px;
`;

export const StyledProgressBar = styled.div<{ progress: number }>`
  position: absolute;
  background: ${({ theme }) => theme.colors.gray3};
  height: 3px;
  bottom: -1px;
  left: 0;
  right: 0;

  &::after {
    content: '';
    display: block;
    background: ${({ theme }) => theme.colors.success};
    height: 100%;
    width: ${({ progress }) => progress}%;
    transition: width 0.05s;
  }
`;
